module.exports = __webpack_public_path__ + "static/media/logo_sq.fb35e635.png";